module.exports = __webpack_public_path__ + "img/report_icon.c20428df.svg";